import { Button } from "@/components/ui/button";
import { StructureSummary } from "@/types/structure";
import { Trash2 } from "lucide-react";

interface DesignDeleteConfirmationDialogProps {
  selectedStructure: StructureSummary | null;
  setShow: (show: boolean) => void;
  show: boolean;
  handleDelete: (id: string) => void;
}
export function DesignDeleteConfirmationDialog({
  selectedStructure,
  setShow,
  show,
  handleDelete,
}: DesignDeleteConfirmationDialogProps) {
  if (!show || !selectedStructure) return null;
  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-background/75 backdrop-blur-[1px]">
      <div className="w-full max-w-md rounded-lg border bg-background p-6 shadow-lg">
        <div className="mb-4">
          <p className="text-xl font-semibold"> Delete Structure? </p>
          <p className="mt-2 text-sm text-muted-foreground">
            Are you sure you want to remove
            <span className="font-semibold text-foreground">{selectedStructure?.name}</span>
            from this Mask?
          </p>
          <p className="mt-2 text-sm text-destructive">
            This action will delete the structure and its related data permanently if it is only
            used on this mask
          </p>
        </div>
        <div className="flex justify-between gap-2">
          <Button variant="outline" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              handleDelete(selectedStructure.id);
            }}
          >
            <Trash2 className="mr-2 h-4 w-4" /> Delete Structure
          </Button>
        </div>
      </div>
    </div>
  );
}
